module.exports = __webpack_public_path__ + "static/media/ChaoMeinespecial.4d47d162.jpg";